import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/apiClient';
import type { Season, PlayerScore } from '../types/scoreboard';

export function useSeasons() {
  return useQuery({
    queryKey: ['seasons'],
    queryFn: () => api.get<Season[]>('/scoreboard/seasons'),
  });
}

export function useSeason(seasonId: string) {
  return useQuery({
    queryKey: ['season', seasonId],
    queryFn: () => api.get<PlayerScore[]>(`/scoreboard/seasons/${seasonId}`),
    enabled: !!seasonId,
  });
}
